import { action } from 'sky-engine/api/index'

import { CAL_SERVER_ORDER_MNG, CAL_SOFTWARE_MNG } from '@/api/apiModules'

/**
 * 创建资源配置订单
 * @param {*} data
 * @returns
 */
export function createOrUpdate(data) {
  return action(CAL_SERVER_ORDER_MNG, 'createOrUpdate', data)
}

/**
 * 创建资源配置订单
 * @param {*} data
 * @returns
 */
export function deleteOrder(data) {
  return action(CAL_SERVER_ORDER_MNG, 'delete', data)
}

/**
 * 详情
 * @param {*} data
 * @returns
 */
export function orderDetail(data) {
  return action(CAL_SERVER_ORDER_MNG, 'detail', data)
}

/**
 * 计算云桌面的配置
 * @param {*} data
 * @returns
 */
export function desktopResourceCalculate(data) {
  return action(CAL_SERVER_ORDER_MNG, 'desktop/resource/calculate', data)
}

/**
 * 计算场景关联的服务器结果列表
 * @param {*} data
 * @returns
 */
export function calServerResourceBySegmentScene(data) {
  return action(CAL_SERVER_ORDER_MNG, 'server/resource/segmentScene/calculate', data)
}

/**
 * 计算服务器的配置
 * @param {*} data
 * @returns
 */
export function calServerResource(data) {
  return action(CAL_SERVER_ORDER_MNG, 'server/resource/calculate', data)
}

/**
 * 元素类型推荐的内容
 * @param {*} data
 * @returns
 */
export function getElementRecommend(data) {
  return action(CAL_SERVER_ORDER_MNG, 'element/recommend', data)
}

/**
 * 元素类型推荐的内容
 * @param {*} data
 * @returns
 */
export function getCalSoftwareList() {
  const params = {
    exactMatchArr: [],
    matchArr: [],
    page: 0,
    limit: 1000
  }
  return action(CAL_SOFTWARE_MNG, 'list', params)
}
